import { makeAutoObservable, reaction, type IReactionDisposer } from 'mobx'
import type { IEntitiesStore } from 'entities/EntitiesExport'
import { QuietHours } from 'entities/QuietHours/model'

export class QuietHoursSettingsStore {
  private readonly _quietHours: QuietHours
  private _disposeReaction: IReactionDisposer | null = null

  constructor(private _entities: IEntitiesStore) {
    makeAutoObservable(this)
    this._quietHours = new QuietHours(this._entities.organizationStore.quietHoursSettings)
    this._setupReaction()
  }

  private _setupReaction = () => {
    this._disposeReaction?.()
    this._disposeReaction = reaction(
      () => this._entities.organizationStore.quietHoursSettings,
      (settings) => {
        if (settings) this._quietHours.syncOrigin(settings)
      }
    )
  }

  get isQuietHoursEnabled() {
    return this._quietHours.isQuietHoursEnabled
  }

  get isShowQuietHours() {
    if (!this._entities.featureFlagsStore.quiet_hours || !this.user) {
      return false
    }
    return (
      (this.isQuietHoursEnabled && !this.user.isViewOnlyRole) ||
      (!this.isQuietHoursEnabled && !(this.user.isViewOnlyRole || this.user.isMemberRole))
    )
  }

  get isQuietHoursBlockOnWeekend() {
    return this._quietHours.isQuietHoursBlockOnWeekend
  }

  get quietHoursAllowedTimeFrom() {
    return this._quietHours.formatedQuietHours.allowedTimeFrom
  }

  get quietHoursAllowedTimeTo() {
    return this._quietHours.formatedQuietHours.allowedTimeTo
  }

  get user() {
    return this._entities.usersStore.user
  }

  dispose = () => {
    this._disposeReaction?.()
    this._disposeReaction = null
  }
}
